import { AlertService } from './../../Services/alert.service';
import { AuthService } from './../../Services/auth.service';
import { SponsorService } from './../../Services/sponsor.service';
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import * as _ from "lodash"
import { Router } from '@angular/router';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-sponsor-list',
  template: require('./sponsor-list.component.html'),
  styles: [require('./sponsor-list.component.css')]
})
export class SponsorListComponent implements OnInit {
  sponsorList: any[] = [];
  current_sponsor: any = {};

  @ViewChild("fileInput") fileInput: ElementRef;

  constructor(private sponsorService: SponsorService,
    private auth: AuthService,
    private alertService: AlertService,
    private router: Router) { }

  ngOnInit() {
    this.getAllSponsors();

  }

  private getAllSponsors() {
    // console.log("Get all sponsors")
    this.sponsorService.getAllSponsors().subscribe(x => {
      this.sponsorList = this.splitIntoMatrix(x);
      // console.log(this.sponsorList);
      // console.log(this.sponsorList);
    })
  }

  private splitIntoMatrix(someArray: any[]) {
    var groupSize = 4;

    var groups = _.map(someArray, function (item: any, index: number) {
      return index % groupSize === 0 ? someArray.slice(index, index + groupSize) : null;
    }).filter(function (item: any) {
      return item;
    });
    return groups;
  }

  SponsorLinkClicked(sponsor: any) {
    console.log("Sponsor Link klicked: ");
    console.log(sponsor);
    this.current_sponsor = sponsor;
  }

  SponsorDeleteClicked(sponsor: any) {
    Swal.fire({
        title: 'Ben je zeker?',
        text: "Ben je zeker dat je deze sponsor wil verwijderen?",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Jep',
        cancelButtonText: 'Nope'
      }).then((result) => {
        if (result.value) {
          this.sponsorService.delete(sponsor.id).subscribe(x => {
            console.log(x);
            if (x.status == 200) {
              this.alertService.success("success", false);
      
            }
            if (x.status == 403) {
              this.alertService.error("Geen access");
            }
            this.getAllSponsors();
      
          });
        }
      });   
  }

  uploadFoto(sponsor: any) {
    if (sponsor.id > -1) {
      var nativeElement: HTMLInputElement = this.fileInput.nativeElement;
      if (nativeElement != null) {
        var files = nativeElement.files;
        if (files != null) {
          var file = files[0];
          this.sponsorService.uploadFile(sponsor.id, file).subscribe(x => {
            this.getAllSponsors();
            this.current_sponsor = x;
          })
        }
      }
    }

  }

  submit() {
    console.log("Submit");
    if (this.current_sponsor.id > -1) {
      this.sponsorService.updateSponsor(this.current_sponsor).subscribe(x => {
        if (x.status == 200) {
          this.alertService.success("Bewaren gelukt")
          console.log(x.value)
        }
      })
    }
    else {
      console.log("New Sponsor");
      console.log(this.current_sponsor);
      this.sponsorService.create(this.current_sponsor).subscribe(x => {
        console.log(x);
        if (x.status == 200) {
          this.uploadFoto(x.value);
          this.alertService.success("Sponser aanmaken gelukt.");
        }
        else {
          this.alertService.error("Er is een fout gebeurd bij het bewaren van de sponsor");
        }
        this.getAllSponsors();
      })
    }


  }

  newSponsorClicked() {
    console.log("New Sponsor clicked")
    this.current_sponsor = {};
    this.current_sponsor.id = -1;
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/sponsor-list/sponsor-list.component.ts